<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="$permission.canWrite()&&showCheckbox"
      :show-query="showQuery"
      :get-data-func="getDataFunc"
      :page-sizes="pageSizes"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <!-- <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="query()">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="宿舍地址">
          <el-input size="mini" v-model="params.DormitoryAddr" placeholder="请填写宿舍地址" clearable/>
        </el-form-item>
        <el-form-item label="楼层">
          <el-input size="mini" v-model="params.DormitoryFloor" type="number" placeholder="请填写楼层" clearable/>
        </el-form-item>
        <el-form-item label="宿舍号">
          <el-input size="mini" v-model="params.DormitoryNumber" placeholder="请填写宿舍号" clearable/>
        </el-form-item>
        <el-form-item label="管理人员">
          <el-input size="mini" v-model="params.TeacherName" placeholder="请填写管理人员" clearable/>
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input size="mini" v-model="params.StudentName" placeholder="请填写学生姓名" clearable/>
        </el-form-item>
      </template>
      <template slot="table">
        <el-table-column prop="DormitoryAddr" label="宿舍地址" />
        <el-table-column prop="DormitoryFloor" label="楼层" />
        <el-table-column prop="DormitoryNumber" label="房号" />
        <el-table-column prop="Capacity" label="容纳人数" />
        <el-table-column prop="TeacherNames" label="管理人员" min-width="180" />
        <el-table-column prop="StudentNames" label="当前学生" min-width="180" />
        <el-table-column prop="CreateTime" label="创建时间" :min-width="130"/>
          <!-- <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.CreateTime)}}</span>
          </template>
        </el-table-column> -->
        <el-table-column prop="BedNo" label="床号" v-if="showBed" fixed="right">
          <template slot-scope="{row}">
            <el-select v-model="row.BedNo" v-if="row.Capacity > 0">
              <el-option v-for="item in row.Capacity" :value="item" :label="item<10?'0'+item:item" :key="item" />
            </el-select>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
    <export-dialog ref="exportDialog" />
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import exportDialog from "./exportDialog";
// import termApi from "@/api/ed/term";

export default {
  mixins: [listMixin],
  components: { list, exportDialog },
  props: {
    showCheckbox: {
      type: Boolean,
      default: true,
    },
    showBed: {
      type: Boolean,
      default: false,
    },
    pageSizes: {
      type: Array,
      default: () => [10,20,50,100,500,1000]
    }
  },
  data() {
    return {
      api: require("@/api/lo/dorm").default,
      params: {
        DormitoryAddr: "",
        DormitoryFloor: "",
        DormitoryNumber: "",
        TeacherName: "",
        StudentName: "",
        TermId: null,
        TermName: "",
      },
      // termApi,
      // termList: [],
      isMB: this.$store.state.isMB,
    };
  },
  // beforeMount() {
  //   let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
  //   this.params.TermId = loginInfo.TermId;
  //   this.termApi.list().then((res) => {
  //     if (res.Data && res.Data.length > 0) {
  //       this.termList = res.Data;
  //       if (this.params.TermId) {
  //         res.Data.forEach((e) => {
  //           if (e.TermId == this.params.TermId) {
  //             this.params.TermName = e.TermName;
  //           }
  //         });
  //       } else {
  //         this.params.TermId = res.Data[0].TermId;
  //         this.params.TermName = res.Data[0].TermName;
  //       }
  //       sessionStorage.setItem("termId", this.params.TermId);
  //       this.$refs.list.initQueryParams.TermId = this.params.TermId;
  //       this.$refs.list.initQueryParams.TermName = this.params.TermName;
  //       this.query({ TermId: this.params.TermId });
  //     }
  //   });
  // },
  methods: {
    getDataFunc(params) {
      return new Promise((resolve,reject) => {
        this.api.list(params).then(res => {
          if(res.Code == 0) {
            res.Data.forEach((e,index) => {
              if(!(e.Capacity > 0)) {
                res.Data.splice(index,1);
              } else {
                e.BedNo = 1;
              }
            })
          }
          resolve(res);
        })
      })
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error("删除失败，" + res.Msg);
        }
      });
    },
    export() {
      // this.$refs.exportDialog.open().then((that) => {
      //   that.getData(this.params);
      // });
      this.api.export(this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams));
    },
  },
};
</script>